import axios from "./index";

export const Login = async (data) => {
  let config = {
    url: '/login/',
    method: 'POST',
    data : data
  }
  return await axios(config);
};